<template>
    <form id="onboarding-de" class="wrapper tab-welcome" role="form" method="post">
        <header>
            <span class="new-headline-xlg text-centered">Willkommen bei Vitadio</span>
        </header>

        <div class="text-wrapper">
            <div>
                <strong class="new-headline-lg">Lernen Sie mit Vitadio, was Ihrem Körper gut tut.</strong>
                <p class="new-headline-md">Entwickeln Sie erreichbare Gewohnheiten für Abnehmen und Blutzuckersenkung – von besserer Ernährung, mehr Bewegung bis hin zu erholsamem Schlaf.</p>

                <div class="col-3">
                    <div>
                        <figure>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#A7EFD1"/>
                            <path d="M17.185 23.7444L27.4905 13.5635L28.8594 14.9099L17.185 26.3897L11.7578 21.0547L13.0815 19.7083L17.185 23.7444Z" fill="#00A671"/>
                            </svg>
                        </figure>
                        <span class="new-text-lg text-green">Einfach</span>
                    </div>
                    <div>
                        <figure>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#A7EFD1"/>
                            <path d="M17.185 23.7444L27.4905 13.5635L28.8594 14.9099L17.185 26.3897L11.7578 21.0547L13.0815 19.7083L17.185 23.7444Z" fill="#00A671"/>
                            </svg>
                        </figure>
                        <span class="new-text-lg text-green">Kostenlos</span>
                    </div>
                    <div>
                        <figure>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#A7EFD1"/>
                            <path d="M17.185 23.7444L27.4905 13.5635L28.8594 14.9099L17.185 26.3897L11.7578 21.0547L13.0815 19.7083L17.185 23.7444Z" fill="#00A671"/>
                            </svg>
                        </figure>
                        <span class="new-text-lg text-green">Wirksam</span>
                    </div>
                </div>

                <v-button label="Zum nächsten Schritt" @onClick="next()" position="center"></v-button>
            </div>

            <figure>
                <img loading="lazy" src="imgs/web/img_onboarding_welcome.webp" srcset="imgs/web/img_onboarding_welcome.webp 1x, imgs/web/img_onboarding_welcome@2x.webp 2x" alt="">
            </figure>
        </div>
    </form>
</template>

<script>
    export default {
        methods: {
            next() {
                setTimeout(() => {
                    this.$emit('clicked', 'index')
                }, 250);
            },
        }
    }
</script>